import { getAnalytics } from '@lib/api/analytics'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppThunk } from '@state/store'
import { AxiosInstance } from 'axios'

interface analyticsState {
  columns: any
  list: {
    data: any
    loading: boolean
    isLoaded: boolean
    error: any
  }
}

const initialState: analyticsState = {
  columns: [],
  list: {
    data: [],
    loading: false,
    isLoaded: false,
    error: '',
  },
}

const analytics = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    getAnalyticsStart(state) {
      state.list.loading = true
    },
    getAnalyticsSuccess(state, action: PayloadAction) {
      state.list.data = action.payload
      state.list.loading = false
      state.list.isLoaded = true
      state.list.error = ''
    },
    getAnalyticsFailure(state, action: PayloadAction<string>) {
      state.list.loading = false
      state.list.isLoaded = false
      state.list.error = action.payload
      console.log(action.payload)
    },
    clearAnalyticsSuccess(state) {
      ;((state.list.data = []), (state.list.loading = false), (state.list.isLoaded = false), (state.list.error = ''))
    },
    storeColumnsSuccess(state, action) {
      state.columns = action.payload
    },
    storeNewTabSuccess(state, action) {
      const oldArray: any = state?.columns
      const newArray = oldArray?.concat(action.payload)
      state.columns = newArray
    },
  },
})

export const {
  getAnalyticsStart,
  getAnalyticsSuccess,
  getAnalyticsFailure,
  clearAnalyticsSuccess,
  storeColumnsSuccess,
  storeNewTabSuccess,
} = analytics.actions

export default analytics.reducer

export const fetchAnalytics =
  (api:AxiosInstance, device: any, start: string, end: string, interval: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(getAnalyticsStart())
      const analyticsList = await getAnalytics(api, device, start, end, interval)
      dispatch(getAnalyticsSuccess(analyticsList))
    } catch (err: any) {
      dispatch(getAnalyticsFailure(err?.message))
    }
  }
